export const sendAmplitudeEvent = (eventName, eventProperties) => {
  try {
    const AmplitudeAPI = window.amplitude;
    if (!AmplitudeAPI || typeof AmplitudeAPI.getInstance !== 'function') {
      console.warn('[Amplitude] SDK not loaded or not initialized');
      return;
    }
    const instance = AmplitudeAPI.getInstance();
    if (!instance || typeof instance.logEvent !== 'function') {
      console.warn('[Amplitude] Instance not available or logEvent not available');
      return;
    }
    return instance.logEvent(eventName, eventProperties);
  } catch (error) {
    console.warn('[Amplitude] Error sending event:', error);
  }
};
